(() => {
  class LeddisplayCraft extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      document.querySelectorAll('product-info, .product, .product-information').forEach((el) => {
        el.classList.add('product--leddisplaycraft', 'craft-pdp');
      });
      document.documentElement.classList.add('craft-pdp-page');
      document.body?.classList?.add('craft-pdp-page');
      const boot = () => {
        if (window.HarfmixCraftPdp) {
          window.HarfmixCraftPdp.init({ quoteOnly: false });
          return true;
        }
        return false;
      };
      if (!boot()) [50, 200, 600, 1500].forEach((ms) => setTimeout(boot, ms));
    }
  }

  if (!customElements.get('leddisplay-craft')) {
    customElements.define('leddisplay-craft', LeddisplayCraft);
  }
})();
